import React from 'react';
import './styling/top.css';

export const Top = () => {
    window.onload = () => {
        let myBtn = document.getElementById('top');
        window.addEventListener('scroll', () => {
            if(window.pageYOffset > 250 && window.location.hash === "/"){
                myBtn.classList.add('show');
            }else {
                myBtn.classList.remove('show');
            }
        });
    }
    return (
        <button className="top" id="top" onClick={() => window.scrollTo(0, 0)}>
            <span>^</span>
        </button>
    )
}